import { useQuery } from '@tanstack/react-query'
import { getJurisdictionById } from 'api/wage/getJurisdiction'
import { wageJurisdictionKeys } from './keys'

export const useJurisdictionQuery = (jurisdictionId: number) => {
  return useQuery({
    queryKey: wageJurisdictionKeys.byId(jurisdictionId),
    queryFn: () => getJurisdictionById(jurisdictionId),
  })
}
